/**
 * Common used custom header names
 */
export enum EHeaderName {
  Authorization = 'Authorization',
  ContentType = 'Content-Type',
  XClientCurrentDate = 'X-Client-Current-Date',
  XCompanyId = 'X-Company-Id',
  RequestId = 'Request-Id',
  XSiteIds = 'X-Site-Ids',
  XCalculateEffectiveDate = 'X-Calculate-Effective-Date',
  XPathWithBusinessDate = 'X-Patch-With-Business-Date',
  XSiteGroupId = 'X-Site-Group-Id',
  XCartEntityId = 'X-Cart-Entity-Id',
  XLocales = 'X-Locales',
  XLocalesPrefix = 'X-Locales-Prefix',
}
